import { getRecordingAssetTitle, RecordingAsset, useLinears } from '@kaltura-ott/tvpil-shared';

export const useChannelInfo = (item: RecordingAsset) => {
  const title = getRecordingAssetTitle(item);

  const { linears } = useLinears();
  const channelName = linears.get(item.channelId)?.data.title;

  return { title, channelName };
};
